import { useTranslation } from "react-i18next";

export default function AboutForm({ className }: { className?: string }) {
  const { t } = useTranslation();

  const aboutEmail = import.meta.env.VITE_ABOUT_EMAIL;

  return (
    <div className={className}>
      <span className="mt-2 text-center">{t("login.aboutInfo")}</span>
      <span className="mt-2 text-center">
        {t("login.wantToTry")}{" "}
        <a
          className="text-dobu-orange hover:text-dobu-orange-focus font-bold text-center cursor-pointer"
          href={`mailto:${aboutEmail}`}
        >
          {aboutEmail}
        </a>
      </span>
    </div>
  );
}
